(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('UserAdminDeleteController', UserAdminDeleteController);

    UserAdminDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserAdmin'];

    function UserAdminDeleteController ($uibModalInstance, entity, UserAdmin) {
        var vm = this;

        vm.user = entity;
        vm.deleteError = null;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            vm.deleteError = null;
            UserAdmin.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                },
                function (error) {
                    vm.deleteError = (error.headers && error.headers('X-wamasysApp-detail')) || 'Suppression impossible.';
                });
        }
    }
})();
